import { Plus } from '@phosphor-icons/react';
import { Button } from 'antd';

/** Add Packaging — aligned to the right of Settings tabs. */
export function SettingsPackagingToolbar({ onAdd }) {
  return (
    <Button type="primary" icon={<Plus size={16} />} onClick={onAdd}>
      Packaging
    </Button>
  );
}
